import React from 'react';
import ToolbarButton, {
  ToolbarButtonGroup,
} from '../../editor/controls/toolbar/buttons/ToolbarButton';
import checkIcon from '../../icons/check.svg';
import unlinkIcon from '../../icons/editor/unlink.svg';
import addTestId from '../../utils/addTestId';
import styles from './AnnotationLinkInput.module.scss';

interface AnnotationLinkInputProps {
  value: string;
  onChange(value: string): void;
  onSave(): void;
  onRemoveLink?: () => void;
}

const AnnotationLinkInput = ({
  value,
  onChange,
  onSave,
  onRemoveLink,
}: AnnotationLinkInputProps) => {
  return (
    <form
      {...addTestId('annotation-link-input-form')}
      onSubmit={(e) => {
        e.preventDefault();
        onSave();
      }}
      className={styles.container}
    >
      <input
        autoFocus
        className={styles.input}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Paste a reference link"
      />
      <ToolbarButtonGroup>
        {onRemoveLink != null && (
          <ToolbarButton
            tooltip="Remove Link"
            icon={unlinkIcon}
            buttonType="button"
            onClick={onRemoveLink}
          />
        )}
        <ToolbarButton tooltip="Save" icon={checkIcon} buttonType="submit" />
      </ToolbarButtonGroup>
    </form>
  );
};

export default AnnotationLinkInput;
